import { MuiThemeProvider } from '@material-ui/core';
import { SimplePaletteColorOptions } from '@material-ui/core/styles/createPalette';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { HashRouter, Route } from "react-router-dom";
import ConnectedMainContainer from './components/container/ConnectedMainContainer';
import ConnectedNavigationWrapper from './components/navigation/ConnectedNavigationWrapper';
import NavigationEntriesData from './data/NavigationEntriesData';
import { Footer } from '@ktr/ktr-materialui-react';
import ProductLookup from './components/ProductLookup';
import StoreWatcher from './components/StoreWatcher';
import IntlProviderWrapper from './react-intl/IntlProviderWrapper';
import { Messages } from './react-intl/Translations';
import { updateLanguage } from './redux/language/languageActions';
import { store } from './redux/store';
import { Theme } from '@ktr/ktr-materialui-react';
import { languageMessage } from './types/language';
import { useSelector } from 'react-redux';
import { ApplicationState } from './redux/state';
import Header from './components/header/Header';
import { CookieBanner } from '@ktr/ktr-materialui-react';

//import {unsubscribe} from './components/storesubscribe';
//----------------------------------------------
// Module Declaration for custom theme
declare module '@material-ui/core/styles/createPalette' {

  interface Palette {
    third: SimplePaletteColorOptions
  }
  interface PaletteOptions {
    third?: SimplePaletteColorOptions
  }
}
declare module '@material-ui/core/styles/createTheme' {
  interface ThemeOptions {
    third?: SimplePaletteColorOptions
  }
}


const App: React.FC = () => {
  
  //register service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('service-worker.js',{scope: '/clampex/'})  // Optional (if you have a subfolder and not the root you have to change the scope! Also in the manifest file.): ,{scope: '/app/'})
      .then(registration => console.log('Service worker successfully registered for:', registration.scope))
      .catch(err => console.log('Service worker registration failed:',err));
}




  let currentTheme: any = Theme.whiteKTRTheme;
  const currentLanguage = useSelector<ApplicationState, languageMessage>(state => state.language.currentLanguage);

  function changeLanguage(languageCode: string): void {
    const msg = Messages.filter(lang => lang.langcode === languageCode)
    store.dispatch(updateLanguage(msg[0]));
  }
  

  return (
    <IntlProviderWrapper messages={Messages[1]}>
      <CookieBanner.default
         googleAnalytics={
          {
            googleAnalytics: true, //turn google analytics integration on
            googleAnalyticsPagePath: window.location.pathname + window.location.hash  //set the googleAnalytics Path. (Path of your application) Important!!
              } as CookieBanner.AnalyticsSettings
          } //
        salesViewer={true}
        cookiename="ktr-cookie-compliance" 
        language={currentLanguage.langcode}>
        </CookieBanner.default>
      <StoreWatcher />
      <MuiThemeProvider theme={currentTheme}>
        { /*//@ts-ignore */}
        <SnackbarProvider autoHideDuration={3000} maxSnack={3}>
          <div className="App">
            <Header
              showLanguageChanger={true}
              languages={Messages}
              //languageHelperText={f({ id:'app.containerBasicLabel' })}
              getLanguageLabel={(lang: languageMessage) => { return lang.language }}
              getLanguageValue={(lang: languageMessage) => { return lang.langcode }}
              getLanguageSelected={(lang: languageMessage) => { return lang === currentLanguage }}
              getCurrentLanguage={() => { return currentLanguage.language}}
              onLangChange={(lang: languageMessage) => changeLanguage(lang.langcode)}
            />
            <ConnectedNavigationWrapper navBarButtons={NavigationEntriesData} />
            
            <ConnectedMainContainer />
            <HashRouter>
              <Route path="/:id" component={ProductLookup} />
              {
                <Route exact path="/" component={ProductLookup} />
              }
            </HashRouter>
            <Footer language={currentLanguage.langcode} />
          </div>
        </SnackbarProvider>
      </MuiThemeProvider>
    </IntlProviderWrapper>
  );
}

export default App;
